export const createUserService = (http, baseUrl) => {
  const buildURL = (path) => `${baseUrl}${path}`

  return {
    getGoogleConfig (surface) {
      const params = new URLSearchParams({ surface })
      return http.get(buildURL(`/auth/google/config?${params}`), { authenticated: false })
    },

    exchangeGoogleCredential (surface, credential) {
      return http.post(buildURL('/auth/google'), { surface, credential }, { authenticated: false })
    },

    getInfo () {
      return http.get(buildURL('/user/info'))
    }
  }
}
